import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid red',
      // height: '95%',
      // margin: '30px 30px 0px 40px',
      padding: '22px 17px 26px 34px'
      // width: '1360px',
    },
    siteform: {
      // height: '85%',
      display: 'flex',
      justifyContent: 'space-between',
      // width: '1395px',
      // overflow: 'auto',
      // border: '2px solid blue',

      '@media (max-width:768px)': {
        flexDirection: 'column'
      }
    },
    buttons: {
      height: '60px',
      // border: '2px solid green',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      backgroundColor: '#FFF',
      marginBottom: '5px',
    },
    dividerroot: {
      marginBottom: '5px',
    },
    layoutsitedata: {
      // border: '2px solid red',
      width: '48%',
      height: '100%',

      '@media (max-width:768px)': {
        width: '100%',
      }
    },
    formfieldslayoutsitedata: {
      //   border: '2px solid pink',
      width: '90%',
      paddingLeft: '12px',
      // height: '90%'
      // margin: '10px 0px 0px 10px',
    },
    formfieldssitedata: {
      // border: '2px solid green',
      width: '100%',
      height: '57px',
    },
    formfieldvaluessitedata: {
      //   border: '2px solid red',
      // display: 'flex',
      // justifyContent: 'space-between',
      // alignItems: 'center',
      // width: '100%'
    },
    rootsitedata: {
      width: '100%',
      // border: '2px solid red',
    },
    inputlabelrootsitedata: {
      width: '100%',
    },
    formControlsitedata: {
      // border: '2px solid red',
      // margin: '0px 10px 10px 10px',
      // width: '600px',
      // height: '35px',
    },
    layoutsitefiles: {
      // border: '2px solid green',
      width: '48%',
      height: '100%',

      '@media (max-width:768px)': {
        width: '100%',
      }
    },
    fileuploadlayoutsitefiles: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexFlow: 'wrap',
      marginBottom: '10px'
      // alignItems: 'center',
      // padding: '5px 0px 0px 0px',
      // marginTop: '20px',
      // // border: '2px solid green',
      // overflow: 'auto',
    },
    menuPaper: {
      overflowY: 'auto',
      maxHeight: '250px',
    },
    errorMessage: {
      fontSize: '10px',
      marginRight: '4px',
      color: '#939497',
    },
    errorLayout: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      width: 'auto',
    },
    formCheckboxLabel: {
      fontSize: '14px',
      marginBottom: '10px',
      marginLeft: '10px',
    },
    checkboxLabel: {
      fontWeight: 'bold',
      fontSize: '16px',
    },
    links: {
      color: '#ff8c00',
      textDecoration: 'none',
    },
  }),
  { index: 1 },
)

export { useStyles }
